export const users = {
  appBarTitle: "Users",
  totalFleetOwners: "Fleet Owner",
  totalSingleOwners: "Single Owner",
  totalTrips: "Number of Trips",
  totalKms: "Covered KMs",
  totalMaintenances: "Expenses Logged",
  totalDeletedLogs: "Deleted Expenses Logs",
  totalDrivers: "Driver",
  totalWhitelistedDrivers: "Qualified Driver",
  totalStandardDrivers: "Standard Driver",
  fleetOwner: "Fleet Owner",
  singleOwner: "Single Owner",
  driver: "Driver",
  user: "User",
  totalCompletedProfiles: "Completed Profile",
  totalVehiclesAdded: "Vehicle Added",
  segments: {
    uncategorizedBasic: "Uncategorized",
    pvBasic: "PV Classic",
    pvSilver: "PV Silver",
    pvGold: "PV Gold",
    pvPlatinum: "PV Platinum",
    cvBasic: "CV Classic",
    cvSilver: "CV Silver",
    cvGold: "CV Gold",
    cvPlatinum: "CV Platinum",
  },
  table: {
    name: "Name",
    phoneNumber: "Phone Number",
    numberOfVehicles: "Vehicles",
    numberOfDrivers: "Drivers",
    numberOfTripsOwners: "Number of Trips",
    totalCoveredKms: "Total Covered KMs",
    numberOfMainetnances: "Expenses",
    teamName: "Team Name (Owner Name)",
    joiningDate: "Joined",
    joiningDateTooltip: "Joining Date",
    numberOfPendingInvitations: "Pending Invitations",
    numberOfPendingRequests: "Pending Requests",
    numberOfTrips: "Number of Trips",
    driverStatus: "Driver Status",
    level: "Level",
    totalPoints: "Total Collected Points",
    totalKms: "Total Covered KMs",
    totalMaintenances: "Total Expenses Logged",
    nationalId: "National ID",
    roleStatus: "Role Status",
    switchedFrom: "Switched from",
    roleStatusOptions: {
      primary: "Primary",
      switched: "Switched",
    },
    nationalIdStatus: "National ID Status",
    approved: "Approved",
    pending: "Pending",
    rejected: "Rejected",
    notSubmitted: "Not Submitted",
    segment: "Segment",
    owner: "Owner",
    driver: "Driver",
    segmentLevel: "Segment / Level",
    activity: "Activity",
    status: "Status",
    vehiclesShort: "Veh",
    driversShort: "Drv",
    tripsShort: "Trips",
    kmsShort: "KM",
    expensesShort: "Exp",
    pointsShort: "Pts",
    invitationsShort: "Inv",
    requestsShort: "Req",
  },
  filters: {
    joiningDate: "Joining Date",
    role: "Role",
    owner: "Owner",
    driver: "Driver",
    both: "Both",
    numberOfVehicles: "Number of Vehicles",
    numberOfTrips: "Number of Trips",
    driverStatus: "Driver Status",
    numberOfDrivers: "Number of Drivers",
    numberOfMaintenaces: "Number of Expenses",
    expenseType: "Expense Type",
    totalCoveredKms: "Total Covered KMs",
    level: "Level",
    collectedPoints: "Collected Points",
    teamStatus: "Team Status",
    nationalId: "Users with National ID",
    roleStatus: "Role Status",
    profileStatus: "Profile Status",
    nationalIdVerificationStatus: "National ID Verification Status",
    segment: "Segment",
    options: {
      vehicles: {
        zero: "Zero",
        moreThanOrEqual1: "More than or equal 1",
        moreThanOrEqual3: "More than or equal 3",
        moreThanOrEqual5: "More than or equal 5",
        moreThanOrEqual10: "More than or equal 10",
      },
      drivers: {
        zero: "Zero",
        moreThanOrEqual1: "More than or equal 1",
        moreThanOrEqual3: "More than or equal 3",
        moreThanOrEqual5: "More than or equal 5",
        moreThanOrEqual10: "More than or equal 10",
      },
      maintenances: {
        zero: "Zero",
        moreThanOrEqual1: "More than or equal 1",
        moreThanOrEqual3: "More than or equal 3",
        moreThanOrEqual5: "More than or equal 5",
        moreThanOrEqual10: "More than or equal 10",
      },
      trips: {
        zero: "Zero",
        moreThanOrEqual1: "More than or equal 1",
        moreThanOrEqual5: "More than or equal 5",
        moreThanOrEqual10: "More than or equal 10",
      },
      coveredKms: {
        zero: "Zero",
        moreThanOrEqual1: "More than or equal 1 Km",
        moreThanOrEqual10: "More than or equal 10 Km",
        moreThanOrEqual50: "More than or equal 50 Km",
        moreThanOrEqual100: "More than or equal 100 Km",
        moreThanOrEqual1000: "More than or equal 1000 Km",
      },
      points: {
        zero: "Zero",
        moreThanOrEqual50: "More than or equal 50",
        moreThanOrEqual100: "More than or equal 100",
        moreThanOrEqual1000: "More than or equal 1000",
        moreThanOrEqual2000: "More than or equal 2000",
        moreThanOrEqual4000: "More than or equal 4000",
        moreThanOrEqual5000: "More than or equal 5000",
        moreThanOrEqual15000: "More than or equal 15000",
      },
      teamStatus: {
        inTeam: "In Team",
        offTeam: "Off Team",
      },
      nationalId: {
        yes: "Yes",
        no: "No",
      },
      singleOwnerRoleStatus: {
        primary: "Primary",
        switchedFromFleetOwner: "Switched from Fleet Owner",
        switchedFromDriver: "Switched from Driver",
      },
      fleetOwnerRoleStatus: {
        primary: "Primary",
        switchedFromSingleOwner: "Switched from Single Owner",
        switchedFromDriver: "Switched from Driver",
      },
      driverRoleStatus: {
        primary: "Primary",
        switchedFromSingleOwner: "Switched from Single Owner",
        switchedFromFleetOwner: "Switched from Fleet Owner",
      },
      profileStatus: {
        completed: "Completed",
        incomplete: "Incomplete",
      },
      nationalIdVerificationStatus: {
        notSubmitted: "Not Submitted",
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected",
      },
    },
  },
  driversList: {
    whiteListedDrivers: 'Qualified drivers',
    standardDrivers: 'Standard drivers',
    driverStatus: 'Driver Status',
    whitelisted: 'Qualified',
    standard: 'Standard',
    editDriverStatus: 'Update Driver Status',
    whiteListingConfirmMsg1: 'Are you sure you want to add ',
    whiteListingConfirmMsg2: ' to the qualified list?',
    standardConfirmMsg1: 'Are you sure you want to remove ',
    standardConfirmMsg2: ' from the qualified list?',
    addToWhiteList: 'Add to qualified list',
    removeFromWhitelist: 'Remove from qualified list',
    addToWhiteListMsg:
      'Are you sure you want to add the selected drivers to the qualified list?',
    removeFromWhitelistMsg:
      'Are you sure you want to remove the selected drivers from the qualified list?',
    bulkQualifying: {
      modalTitle: 'Import Qualified Drivers',
      phoneNumber: 'Phone Number',
      uploadLabel: 'Upload From Computer',
      addSingleDriver: 'Add Single Driver',
      addMultipleDrivers: 'Add Multiple Drivers',
      unqualifiedDrivers: 'Unqualified Drivers',
      rejectedDriversMsg:
        'Apologies! :successCount drivers are qualified successfully, but failed to upload :failCount drivers. You can download the file below for more details.',
      validations: {
        phoneRequired: 'Phone number is required',
        invalidPhoneNumber: 'Phone number is invalid',
        fileRequired: 'Excel file is required',
      },
      messages: {
        singlePhoneAdded: 'Driver is qualified successfully',
        multiplePhoneAdded: ':count Drivers are qualified successfully',
      },
      excelFileLables: {
        number: 'Number',
        name: 'Driver Name',
        phone: 'Phone Number',
        reason: 'Comment',
      },
    },
  },
  pendingDrivers: {
    phoneNumber: "Driver's Phone Number",
    importDate: 'Import Date',
    TotalPendingDrivers: 'Total Pending Drivers',
    table: {
      driverName: "Driver's name",
      phoneNumber: "Driver's Phone Number",
      ownerName: "Owner's name",
      importDate: 'Import Date',
      invitationsStatus: 'Invitation Status',
      driverStatus: "Driver's Status",
    },
    filters: {
      importedDate: 'Imported Date',
      teamName: 'Team Name',
      invitationStatus: 'Invitation Status',
      qualificationStatus: 'Qualification Status',
      options: {
        invitation: {
          invited: 'Invited',
          notInvited: 'Not Invited',
        },
        qualification: {
          qualified: 'Qualified',
          notQualified: 'Not Qualified',
        },
      },
    },
    qualified: "Qualified",
    notQualified: "Not Qualified",
    invited: "Invited",
    notInvited: "Not Invited",
    totalPendingDrivers: "Pending Driver",
    totalQualifiedDrivers: "Qualified Driver",
    totalUnqualifiedDrivers: "Unqualified Driver",
    editDriverStatus: "Update Driver Status",
    qualifyConfirmMsg: "Are you sure you want to qualify :driver ",
    disqualifyConfirmMsg: "Are you sure you want to disqualify :driver ",
    driver: "this driver",
  },
  userDetails: {
    userProfile: 'User Profile',
    dateOfBirth: 'Date of birth',
    job: 'Job',
    location: 'Location',
    gender: 'Gender',
    phoneNumber: 'Phone Number',
    email: 'Email',
    joiningDate: 'Joining date',
    verificationDate: 'Verification date',
    level: 'Level',
    blockConfirmation:
      "Blocked users will be logged out & won’t be able to login anymore until being unblocked",
    unblockConfirmation: "User will be able to use the app again normally",
    switchedFrom: "Switched from",
    primary: "Primary",
    nationalIdVerificationStatus: "National ID Verification Status",
    nationalIdVerificationStatusOptions: {
      notSubmitted: "Not Submitted",
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
    },
    nationalIdDetails: "National ID Details",
    nidFullName: "Full Name",
    nidBirthDate: "Birth Date",
    nidGender: "Gender",
    nidAddress: "Address",
    nidReligion: "Religion",
    nidMaritalStatus: "Marital Status",
    nidProfession: "Profession",
    roles:{
      singleOwner: "Single Owner",
      fleetOwner: "Fleet Owner",
      driver: "Driver",
    },
    fleetOwner: {
      totalTeamTrips: "Total number of team trips",
      totalKmsCovered: "Total number of KMs covered in all the trips",
      totalMaintenances: "Total number of expenses logged",
      totalExpenses: "Total amount of expenses",
      pendingInvitations: "Pending invitations",
      pendingRequests: "Pending requests",
      teamDriversList: "Team Drivers List",
      fleetOwner: "Fleet Owner",
      table: {
        driverName: "Driver Name",
        phoneNumber: "Phone Number",
        status: "Status",
        totalPointsCollected: "Total Points Collected",
        level: "Level",
        joiningDate: "Joining Team Date",
        numberOfTrips: "Number of Trips",
        totalCoveredKms: "Total Number of Covered KMs",
        maintenanceLogs: "Expenses Logs",
        totalExpenses: "Total Expenses",
        driverStatus: {
          inTeam: 'In Team',
          left: 'Left Team',
        },
      },
    },
    singleOwner: {
      totalTeamTrips: "Total number of team trips",
      totalKmsCovered: "Total number of KMs covered in all the trips",
      totalMaintenances: "Total number of expenses logged",
      totalExpenses: "Total amount of expenses",
      pendingInvitations: "Pending invitations",
      pendingRequests: "Pending requests",
      vehiclesList: "Vehicles List",
      singleOwner: "Single Owner",
      totalVehiclesAdded: "Total number of vehicles added",
      table: {
        vehicleName: "Vehicle Name",
        vehicleBrand: "Vehicle Brand",
        vehicleType: "Vehicle Type",
        odometerReading: "Odometer Reading",
      },
    },
    driver: {
      totalKmsCovered: "Total number of covered KMs for all ended trips",
      totalMaintenances: "Total number of added expense logs",
      totalExpenses: "Total amount of expenses",
      totalPoints: "Total number of points collected",
      totalRewards: "Total number of rewards earned or redeemed",
      pointsDetails: "Points Details",
      rewardsDetails: "Rewards Details",
      requestsDetails: "Requests Details",
      driver: "Driver",
      table: {
        points: 'Points',
        pointsType: 'Type',
        collectionDate: 'Date of Collection',
        requiredPoints: 'Required Points',
        status: 'Status',
        rewardsType: 'Type',
        amount: 'Amount',
        earningDate: 'Date of Earning',
        level: 'Level',
        requestNumber: 'Request Number',
        requestDate: 'Request Date',
        attachments: 'Attachments',
        decisionDate: 'Decision Date',
        actions: 'Actions',
        viewAttachments: 'View Attachments',
        approve: 'Approve',
        reject: 'Reject',
        driverLicense: "Driver's License",
        personalPhoto: 'Personal Photo',
        attachmentsNoLongerAvailable: 'Attachments are no longer available',
        pointsTypes: {
          completeProfile: "Completing Profile",
          watchTutorial: "Watching Tutorial",
          completeTrip: "Completing Trip",
          addMaintenance: "Adding Expense",
          joinTeam: "Join Team",
        },
        rewardStatus: {
          earned: 'Earned',
          redeemed: 'Redeemed',
          expired: 'Expired',
        },
        rewardType: {
          voucher: 'Voucher',
          rechargeCard: 'Recharging Card',
          discount: 'Discount',
        },
        verificationRequest: {
          approveRequest: 'Approve Request',
          approvedRequestMsg:
            "The entered license number is valid and will be saved in the driver's details. Are you sure you want to approve this verification request?",
          rejectRequest: "Reject Request",
          rejectRequestMsg:
            "Please provide a reason to reject this verification request",
          saveLicenseData: "Approve License Number",
          enterLicenseNumber: "Enter License Number",
          rejectionReason: "Rejection Reason",
          selectRejectionReason: "Select rejection reason",
          viewRejectionReason: "View rejection reason",
          validations: {
            licenseRequired: "License Number is required",
            licenseLength: "License Number should consist of 14 digits",
            licenseValid:
              "License Number should consist of numbers only, no letters or special characters allowed",
            licenseCurrentlyExist:
              "The entered license number is already associated with a registered driver, ",
            cannotBeReused: "it cannot be reused.",
            licensePreviouslyExist1: "The entered license number ",
            matchesDeletedDriver: "matches a deleted driver. ",
            licensePreviouslyExist2: "Are you sure you want to proceed ?",
            rejectionReasonRequired: "Rejection Reason is required",
            invalidNationalId: "Invalid National ID",
          },
        },
      },
      standard: 'Standard',
      whiteListed: 'Qualified',
      editDriverStatus: 'Update Driver Status',
      whiteListingConfirmMsg1: 'Are you sure you want to add ',
      whiteListingConfirmMsg2: ' to the qualified list?',
      standardConfirmMsg1: 'Are you sure you want to remove ',
      standardConfirmMsg2: ' from the qualified list?',
    },
    referralDetails: {
      referralRewards: "Referral Rewards",
      inviteeName: "Invitee Name",
      inviteeRole: "Invitee Role",
      phoneNumber: "Phone Number",
      inviteeStatus: "Invitee Status",
      invitationDate: "Invitation Date",
      rewardStatus: "Reward Status",
      rewardAmount: "Reward Amount",
      redemptionDate: "Redemption Date",
      roles: {
        singleOwner: "Single Owner",
        fleetOwner: "Fleet Owner",
        driver: "Driver",
      },
    },
  },
};
